import { mapGetters, mapActions } from "vuex";
import { changeUserEnterprise } from '@/api/user'
export const list = {
  data(){
    return {
      loading:false,
      btnLoading:false,
      tableLoading:false,
      list:[],
      page:{
          pageNum:1,
          pageSize:10,
          total:0,
      },
      selectedRowKeys:[],
      selectedRows:[],
      detail:{}
    }
  },
  created(){
    this.init()
  },
  methods:{
    ...mapActions(['updateLoading']),
    clearFormAll(keyName="form",formValue={},fucName="getList"){
      this[keyName] = formValue
      this[fucName]()
    },
    init(){
      //TOOL
    },
    //刷新登录信息
    reLoadUser(){
      changeUserEnterprise({eNo:this.user.eNo}).then(res =>{
        this.$router.go(0)
      })
    },
    //跳转
    tolink(url,param){
      if(param){
        this.$router.push({path: url,query:param});
      }else{
        this.$router.push({path: url});
      }
    },
    filterOption(input, option) {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    checkSpaceAvailable(){
      if(this.spaceExpired){
        this.$message.warning('企业空间已到期，请续费！')
        return false
      }
      if(this.remaining<=0){
        this.$message.warning('企业空间不足，请补充空间！')
        return false
      }
      return true
    }
  },
  computed: {
    ...mapGetters(["user"]),
    rowSelection() {
      return {
          selectedRowKeys: this.selectedRowKeys,
          onChange: (selectedRowKeys, selectedRows) => {
              this.selectedRowKeys = selectedRowKeys;
              this.selectedRows = selectedRows
              // 选中的信息
              // console.log(selectedRows)
          },
      };
    },
    remaining(){
        let remNum = this.user.member.enterpriseAssets.paySpace+this.user.member.enterpriseAssets.freeSpace-this.user.member.enterpriseAssets.usedSpace
        return remNum
    },
    spaceExpired(){
        if(!this.user.member.enterpriseAssets.spaceExpiryDate) return false
        return new Date(this.user.member.enterpriseAssets.spaceExpiryDate).getTime() < Date.now()
    }
  }
}
